export enum UserClaim {
  CanReportActivity = 'CanReportActivity',
  CanUpdateActivity = 'CanUpdateActivity',
  CanReportDistrictActivity = 'CanReportDistrictActivity',
  CanReportClubActivitybyDistrict = 'CanReportClubActivitybyDistrict',
  CanReportMDActivity = 'CanReportMDActivity',
  CanReportClubActivitybyMultiDistrict = 'CanReportClubActivitybyMultiDistrict',
  CanReportDistrictActivityByMultiDistrict = 'CanReportDistrictActivitybyMultiDistrict',
  LocalLanguage = 'LocalLanguage',
  MyLion = 'MyLion',
  ResetPassword90 = 'ResetPassword90',
  ClubMembership = 'ClubMembership',
  MemberRole = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role',
  MemberId = 'MemberId',
  Member = 'Member',
  Guest = 'Guest',
  Country = 'JAPAN',
  ShopJapan = 'Shop Japan',
  Shop = 'Shop'
}
